import { render, staticRenderFns } from "./FinancialStatementBillingPendenciesCustomer.vue?vue&type=template&id=d9e623d0"
import script from "./FinancialStatementBillingPendenciesCustomer.vue?vue&type=script&lang=ts"
export * from "./FinancialStatementBillingPendenciesCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports